import { shallowMount } from "@vue/test-utils";
import formValidator from "@/mixins/form-validator";
import bus from "@/bus";
import Vue from "vue";

Vue.mixin(formValidator);

describe("form-validator.js", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = shallowMount(Vue, {
      propsData: {
        required: true
      }
    });
  });

  it("should have validCheck as false by default", () => {
    expect(wrapper.vm.validCheck).toBe(false);
  });

  it("checkValid sets validCheck to true", () => {
    wrapper.vm.checkValid();
    expect(wrapper.vm.validCheck).toBe(true);
  });

  it("should have required as false by default", () => {
    wrapper.vm.required = false;
    expect(wrapper.vm.required).toBe(false);
  });

  it("should be valid if not required", () => {
    wrapper.vm.required = false;
    expect(wrapper.vm.isValid()).toBe(true);
  });

  it("should not be valid if required and has no value", () => {
    wrapper.vm.$data.value = "";
    expect(wrapper.vm.isValid()).toBe(false);
  });

 

  it("error returns null when validCheck is false", () => {
    wrapper.vm.validCheck = false;
    expect(wrapper.vm.error).toBe(null);
  });

  it("error returns error message when validCheck is true and isValid es false", () => {
    wrapper.vm.validCheck = true;
    expect(wrapper.vm.error).toBe("Tenés que ingresar este dato");
  });
});